/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { get, getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { withStyles } from '@material-ui/core/styles';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Pagination from 'modules/common/components/Pagination';

import * as c from '../constant';
import * as actions from '../action';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const ExportsContainer = ({ getExportsList, exportsList, classes, pager }) => {
  // const permissions = getJson('permissions');
  const [formData, setFormData] = useState({
    date_from: `${moment(new Date()).format('MM/DD/YYYY')}`,
    date_to: `${moment(new Date()).format('MM/DD/YYYY')}`,
  });
  const isLoading = false;

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState('');

  const handleDownload = id => {
    const path = `${
      process.env.REACT_APP_WS
    }api/v1/administrators/report_file_exports_download/${id}?bearer_token=${token}
    &email=${_.get(authProfile, 'email')}`;
    return `${path}`;
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);

    const datedToday = {
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      type: _.get(formData, 'type'),
    };
    getExportsList(datedToday);
  }, []);

  const handleDateChange = key => ({ target: { value } }) => {
    if (
      key === 'date_from' &&
      `${moment(new Date(value)).format('yyyy-MM-DD')}` >
        `${moment(new Date(_.get(formData, 'date_to'))).format('yyyy-MM-DD')}`
    ) {
      Alert.warning('Invalid filter, Date From is greater than Date To');

      setFormData({
        ...formData,
        [key]: '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleSearch = e => {
    e.preventDefault();
    getExportsList({
      date_from: moment(_.get(formData, 'date_from')).format('yyyy-MM-DD'),
      date_to: moment(_.get(formData, 'date_to')).format('yyyy-MM-DD'),
      type: _.get(formData, 'type'),
    });
  };

  const handleChangePage = page => {
    const args = {
      ...formData,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      type: _.get(formData, 'type'),
      page,
    };

    getExportsList(args);
  };

  return (
    <>
      <div className="">
        <div className="row p-3">
          {/* <div className="col-md-12 col-lg-6 col-xl-12 d-flex">
            <h3 className="row-nav font-weight-bold text-color">
              Exported Reports
            </h3>
          </div> */}
        </div>
        <form onSubmit={handleSearch} className="mb-5">
          <div className="d-flex row">
            <div className="form-input-group ml-2">
              <label className="label-reports">Export Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
            <div className="form-input-group ml-2">
              <label className="label-reports">Export Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
            <div className="col-2 form-input-group ml-2">
              <label className="label-reports">Type</label>
              <Select
                placeholder="Select Type"
                className="full-input"
                onChange={handleChangeSelect('type')}
                options={c.EXPORT_TYPE_OPTIONS}
              />
            </div>
            <div className="form-input-group ml-2">
              <div className="full-input">
                <button
                  disabled={
                    _.isEmpty(_.get(formData, 'date_from')) ||
                    _.isEmpty(_.get(formData, 'date_to')) ||
                    _.isEmpty(_.get(formData, 'type'))
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
                >
                  <i className="fas fa-search" /> &nbsp;&nbsp;Search
                </button>
              </div>
            </div>
          </div>
        </form>
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              // padding: "10px",
              marginBottom: '20px',
            }}
          >
            <div className="mb-3">
              {exportsList.length > 0 ? (
                <div className="mt-2 table-responsive">
                  <table className="table table-striped table-sm table-bordered table-hover">
                    <thead className="table-header">
                      <tr className="billing-table-tr">
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Type
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Date Exported
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Name
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Path
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Size
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Total Rows
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Status
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="table-details">
                      {exportsList.map(item => {
                        return (
                          <tr
                            className="billing-table-tr"
                            key={_.get(item, 'id')}
                          >
                            <td>
                              {_.get(item, 'attributes.type') || '---'}
                            </td>
                            <td>
                              {_.get(item, 'attributes.date_exported') || '---'}
                            </td>
                            <td>
                              {_.get(item, 'attributes.file_name') || '---'}
                            </td>
                            <td>
                              {_.get(item, 'attributes.file_path') || '---'}
                            </td>
                            <td>{_.get(item, 'attributes.size') || '---'}</td>
                            <td>{_.get(item, 'attributes.total_rows') || '---'}</td>
                            <td>{_.get(item, 'attributes.status') || '---'}</td>
                            <td className="text-center">
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                href={handleDownload(item.id)}
                                target="_blank"
                                without="true"
                                rel="noopener noreferrer"
                              >
                                <i className="fas fa-folder-open mr-2" />{' '}
                                Download
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="text-center mx-auto py-4">
                    <img
                      src={emptyStateImage}
                      className="img-responsive image-wrapper mb-4 mt-3"
                      alt="Empty State"
                    />
                    <p className="emp-title mb-0">No Item Found</p>
                  </div>
                </div>
              )}
            </div>
            <div className="list-pagination">
              {pager.total_pages > 1 && (
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={pager} onChange={handleChangePage} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ExportsContainer.propTypes = {
  getExportsList: PropTypes.instanceOf(Function).isRequired,
  exportsList: PropTypes.instanceOf(Array).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  exportsList: _.get(api, `${c.EXPORTS_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.EXPORTS_LIST) > -1,
  pager: _.get(api, `${c.EXPORTS_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default withStyles(styles)(enhance(ExportsContainer));
